// Note - Why did we make this file as a separate component, for now, we have not made any domain validations, so if domain validation is to be done in the future, this component should be larger. This would be easier for us to do in the future if we made a separate component in addition to adding domain validation

export default function isEmailValid(email) {
  const emailRegex =
    /^[a-zA-Z0-9]+(?:[._+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;
  const isValidFormat = emailRegex.test(email);
  return isValidFormat;
}
